// material-ui
import {} from '@mui/material'
import React from 'react'

import { CircularProgress } from '@mui/material'
import { useInterval } from 'components/utility'
import TitleService from 'title-service'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import ProfileHeader from 'components/ProfileHeader'
import ProfileList from 'components/ProfileList'
import ProfileScene from 'components/ProfileScene'
import ProfileSection from 'components/ProfileSection'
import ProfileSectionContainer from 'components/ProfileSectionContainer'
import { getUserClaims } from 'features/application/application-slice'
import {
  get_all_mobileLoginProxy,
  is_mobileLoginProxy_busy,
} from 'features/mobileLoginProxy/mobileLoginProxy-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let mobileLoginProxy_list = useSelector(get_all_mobileLoginProxy)
  let mobileLoginProxy_busy = useSelector(is_mobileLoginProxy_busy)
  const [proxyId, setProxyId] = React.useState(null)
  const [proxyCode, setProxyCode] = React.useState(null)

  const refreshMobileLogin = useInterval(20000)

  useEffect(() => {
    if (claims?.fire_user) {
      dispatch(
        autoThunks.get_mobile_login_proxies({ userId: claims?.fire_user }),
      )
    }
  }, [claims?.fire_user, refreshMobileLogin])
  useEffect(() => {
    if (claims?.fire_user && JSON.stringify(mobileLoginProxy_list)) {
      function on_mobile_login_proxy_change() {
        let item = mobileLoginProxy_list.find((v) => !v.deleted)
        setProxyId(item?.id)
        setProxyCode(item?.code)
      }
      on_mobile_login_proxy_change()
    }
  }, [claims?.fire_user, JSON.stringify(mobileLoginProxy_list)])

  function main(comp: any): any {
    return (() => {
      return (
        <div className="profile component">
          <ProfileScene>
            <ProfileHeader
              btnTitle={TitleService('Back')}
              onBtnClick={() => {
                history.back()
              }}
            ></ProfileHeader>
            <ProfileSectionContainer>
              <ProfileSection>
                <h2 className="padding--bottom-6 text-color--primary ">
                  {TitleService('Connect')}
                </h2>
                <ProfileList>
                  <div
                    style={{
                      display: 'flex',
                      height: 300,
                      flexDirection: 'row',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                    }}
                  >
                    <div>
                      {(function () {
                        if (!mobileLoginProxy_list) {
                          return null
                        }
                        let qc = mobileLoginProxy_list?.find(
                          (x) => x.owner === claims?.fire_user,
                        )
                        if (qc) {
                          return (
                            <h1 style={{ fontSize: 70 }}>
                              {`${qc.code}`.toUpperCase()}
                            </h1>
                          )
                        }
                      })()}
                    </div>
                    <div style={{ display: 'none' }}>
                      <h1>{TitleService('or')}</h1>
                    </div>
                    <div style={{}}>
                      {proxyId && !mobileLoginProxy_busy ? null : (
                        <CircularProgress size={'6rem'} />
                      )}
                    </div>
                  </div>
                </ProfileList>
              </ProfileSection>
            </ProfileSectionContainer>
          </ProfileScene>
        </div>
      )
    })()
  }

  let output_main = main(null)

  return output_main
}
